export const hasUserFavorited = (nbFavoris = [], userId, articleId) => {
  const listArticleInteracted = JSON.parse(localStorage.getItem("articles"));

  if (userId) {
    if (!Array.isArray(nbFavoris)) return false;
    return nbFavoris.some((entry) => {
      const uid = entry.utilisateur?._id || entry.utilisateur;
      return uid?.toString() === userId?.toString();
    });
  } else {
    if (listArticleInteracted && listArticleInteracted.length > 0) {
      return listArticleInteracted.some(
        (el) => el._id === articleId && el.params === "nbFavoris",
      );
    } else {
      return false;
    }
  }
};

export const getFavorisCount = (nbFavoris = [], artilceId) => {
  const listArticleInteracted = JSON.parse(localStorage.getItem("articles"));
  let value = Array.isArray(nbFavoris) ? nbFavoris.length : 0;
  if (listArticleInteracted && listArticleInteracted.length > 0) {
    const isInclude = listArticleInteracted.filter(
      (el) => el._id == artilceId && el.params == "nbFavoris",
    );
    if (isInclude && isInclude.length > 0) {
      value++;
    }
  }
  return value;
};
